import React, {RefObject, useLayoutEffect, useRef, useState} from "react"
import FieldProgress_TableCellCalculated_NotHovered from "./not-hovered"
import FieldProgress_TableCellCalculated_Hovered from "./hovered"
import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import {useForceUpdate} from "../../../../../../gd/utils/dom-and-react/react-utils"
import {EntityType} from "../../../../../../gd/const/item"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"

// const debug = "FieldProgress_TableCellCalculated"
const debug = false

export default function FieldProgress_TableCellCalculated(props: FieldTableCellProps) {

    const refEditable: RefObject<any> = useRef()

    const forceUpdate                   = useForceUpdate()
    const [isHovered, setIsHovered]     = useState(false)
    const [showPopover, setShowPopover] = useState(false)
    
    let isEditable: boolean
    switch (props.listItem.type) {
        case EntityType.TASK:
        case EntityType.PROJECT:
            isEditable = !props.manager.isReadOnly && (!props.field.isCustom || props.listItem.availableCustomFieldsIds.includes(props.field.fieldId))
            break

        case EntityType.EVENT:
        case EntityType.GROUP:
        default:
            isEditable = false
    }

    useLayoutEffect(()=>{
        if (showPopover) {
            refEditable.current?.onClick()
        }
    }, [showPopover])

    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const hidePopover = () => {
        setShowPopover(false)
    }

    const onValueChange = async (value: any, hidePopover: boolean = true) => {

        if (!props.field.fieldParams.tableCellOnValueChange) {
            console.error("FieldProgress_TableCellCalculated: tableCellOnValueChange is not implemented")
            return
        }

        await props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)

        hidePopover && setShowPopover(false)
        FieldProto_updateView(props.manager, props.field)
    }

    const onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }

        e.stopPropagation()
        onValueChange(null)
        forceUpdate()
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!isEditable) {
            return
        }

        setShowPopover(true)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered || showPopover) {
        return (
            <FieldProgress_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                isEditable      = {isEditable}
                showPopover     = {showPopover}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onValueChange   = {onValueChange}
                hidePopover     = {hidePopover}
                onClick         = {onClick}
                onDeleteClick   = {onDeleteClick}
            />
        )
    } else {
        return (
            <FieldProgress_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
